export const esES = {
  code: "es",
  metaTitle: "Murilo Lodovico — Ingeniero de Software Full Stack",
  metaDescription:
    "Ingeniero de software full stack en Campinas, Brasil. Java, TypeScript, React, Spring Boot y arquitecturas modernas. Abierto a roles remotos o híbridos.",
  skipToContent: "Saltar al contenido",
  openMenu: "Abrir menú",
  closeMenu: "Cerrar menú",
  langLabel: "Idioma",
  navAbout: "Sobre mí",
  navExperience: "Experiencia",
  navSkills: "Stack",
  navProjects: "Proyectos",
  navEducation: "Formación",
  navContact: "Contacto",
  role: "Ingeniero de Software Full Stack",
  currentLabel: "Actualmente",
  currentCompany: "NAVA",
  locationLabel: "Ciudad",
  location: "Campinas, Brasil",
  workModeLabel: "Formato",
  workMode: "Remoto o híbrido",
  heroLead:
    "Diseño y evoluciono productos digitales en front-end y back-end, con Java, TypeScript y arquitecturas modernas. Enfocado en calidad, rendimiento y sistemas fáciles de mantener.",
  ctaExperience: "Ver experiencia",
  ctaResume: "Descargar currículum",
  ctaContact: "Hablar conmigo",
  resume: "Currículum",
  statYears: "6+",
  statYearsLabel: "años construyendo software",
  statStack: "Java + JS",
  statStackLabel: "del dominio a la interfaz",
  statWork: "Remoto / híbrido",
  statWorkLabel: "Campinas y región",
  aboutTitle: "Sobre mí",
  aboutEyebrow: "Perfil",
  aboutP1:
    "Ingeniero de software con trayectoria sólida creando funcionalidades robustas, corrigiendo bugs con eficiencia y mejorando de forma continua la calidad de productos digitales. Trabajo de manera integrada en front-end y back-end, orientado a arquitecturas modernas y buenas prácticas de ingeniería.",
  aboutP2:
    "Especialista en interfaces modernas y performantes con Next.js, React y Angular, usando TypeScript, y con amplia experiencia en back-end con Node.js, NestJS y Java (Spring Boot). Aplico DDD para modelar el dominio, TDD/BDD para validar comportamiento y SOLID para extensibilidad, bajo acoplamiento y alta cohesión.",
  aboutP3:
    "Practico Clean Architecture, Arquitectura Hexagonal y Clean Code: capas bien separadas, reglas de negocio independientes de los detalles de implementación, y puertos y adaptadores para modularidad.",
  principlesTitle: "Cómo construyo",
  experienceTitle: "Experiencia",
  experienceEyebrow: "Trayectoria",
  skillsTitle: "Stack",
  skillsEyebrow: "Herramientas",
  projectsTitle: "Proyectos",
  projectsEyebrow: "Selección",
  projectsIntro:
    "APIs, apps y experimentos que muestran el tipo de trabajo que me gusta entregar.",
  educationTitle: "Formación",
  educationEyebrow: "Base",
  degreeLabel: "Grado",
  degreeTitle: "Ciencias de la Computación",
  degreeSchool: "UNIP",
  degreePeriod: "2018 — 2021",
  degreeDescription:
    "Formación académica en Ciencias de la Computación, con base en algoritmos, ingeniería de software y sistemas.",
  coursesTitle: "Cursos",
  languagesTitle: "Idiomas",
  langEnglish: "Inglés — avanzado",
  langSpanish: "Español — básico",
  contactTitle: "Hablemos",
  contactEyebrow: "Contacto",
  contactLead:
    "Abierto a posiciones remotas o híbridas. Si encaja, escríbeme.",
  contactEmail: "Correo",
  contactWhatsapp: "WhatsApp",
  footer: "Campinas, Brasil",
  viewProject: "Ver en GitHub",
  viewCertificate: "Ver certificado",
  principles: [
    {
      title: "DDD",
      text: "Modelado de dominio alineado al negocio, no solo a la tecnología.",
    },
    {
      title: "TDD / BDD",
      text: "Comportamiento validado pronto, con tests que protegen la evolución.",
    },
    {
      title: "SOLID",
      text: "Extensibilidad, bajo acoplamiento y alta cohesión en el día a día.",
    },
    {
      title: "Clean / Hexagonal",
      text: "Reglas de negocio independientes de frameworks, bases de datos y UI.",
    },
  ],
  experience: [
    {
      company: "NAVA",
      role: "Desarrollador Full Stack / Ingeniero de Software",
      period: "sep/2024 — actual",
      description:
        "Ingeniería backend con foco en Java, Apache Camel e integraciones de alto rendimiento. Migración de sistemas legacy, optimización de performance, modelado de arquitectura y evolución de aplicaciones críticas, aplicando DDD, BDD y SOLID.",
      tags: ["Java", "Apache Camel", "DDD", "BDD", "Integraciones"],
    },
    {
      company: "Upwork",
      role: "Ingeniero de Software",
      period: "ago/2023 — ago/2024",
      description:
        "Soluciones fintech con React, TypeScript, Java y Spring Boot, incluyendo sistemas de pago y módulos ERP. Responsable de nuevas funcionalidades, corrección de bugs e integración de servicios.",
      tags: ["React", "TypeScript", "Java", "Spring Boot", "Fintech"],
    },
    {
      company: "Coopersystem",
      role: "Ingeniero de Software",
      period: "ene/2022 — ago/2023",
      description:
        "Integración de paquetes React Native con Swift y desarrollo de aplicaciones completas en React Native, del concepto a la entrega. También Angular, React, TypeScript, Node.js y AWS S3/EC2.",
      tags: ["React Native", "Swift", "Angular", "Node.js", "AWS"],
    },
    {
      company: "Qyon Intelligent Systems",
      role: "Ingeniero de Software",
      period: "abr/2021 — nov/2021",
      description:
        "Liderazgo del front-end de una app fintech: páginas y componentes en React Native con TypeScript, reuniones técnicas y definición de funcionalidades.",
      tags: ["React Native", "TypeScript", "Fintech"],
    },
    {
      company: "BUTH",
      role: "Desarrollador de Software Jr",
      period: "sep/2020 — abr/2021",
      description:
        "Pantallas y corrección de bugs con React y React Native, TypeScript, Bootstrap y Styled Components. APIs y recursos back-end con Node.js.",
      tags: ["React", "React Native", "Node.js"],
    },
    {
      company: "Matera Financial Risk Retail",
      role: "Pasante",
      period: "ene/2019 — dic/2019",
      description:
        "Java Spring Boot en el desarrollo y corrección de bugs en sistemas ERP complejos, con Docker, Swagger y OracleDB.",
      tags: ["Java", "Spring Boot", "Docker", "Oracle"],
    },
  ],
  skillGroups: [
    {
      title: "Front-end",
      items: ["React", "Next.js", "Angular", "TypeScript", "JavaScript"],
    },
    {
      title: "Back-end",
      items: ["Java", "Spring Boot", "Apache Camel", "Node.js", "NestJS"],
    },
    {
      title: "Mobile",
      items: ["React Native", "Swift"],
    },
    {
      title: "Arquitectura",
      items: ["DDD", "TDD / BDD", "SOLID", "Clean Architecture", "Hexagonal"],
    },
    {
      title: "Cloud y datos",
      items: ["AWS S3", "EC2", "Docker", "MySQL", "MongoDB", "OracleDB", "Swagger"],
    },
  ],
  projects: {
    petshop: "API REST de petshop con NestJS, TypeORM y MySQL.",
    checkIns: "API de check-ins en Java Spring Boot, con Lombok y buenas prácticas de API.",
    goBarber: "Sistema de barbería con React, React Native y Node.",
    gitHunter: "Búsqueda de perfiles de GitHub por ID, hecha en React.",
    mostUsedWords: "Conteo de palabras en un texto, construido con Vue.js.",
    habits: "Seguimiento de hábitos y compromisos en React.",
  },
  courses: [
    {
      title: "Java — Programación Orientada a Objetos",
      subtitle: "02/2023 — 08/2023",
    },
    {
      title: "Web Moderno Completo con JavaScript",
      subtitle: "Udemy · 08/2021 — 05/2022",
    },
    {
      title: "Swift App Development Bootcamp",
      subtitle: "02/2021 — 07/2021",
    },
    {
      title: "Rocketseat GoStack",
      subtitle: "01/2020 — 11/2020",
    },
    {
      title: "Lenguaje Python",
      subtitle: "Udemy · 03/2019 — 04/2019",
    },
  ],
};
